import { Icon24VideoMatteLarge } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const VideoMatteIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M18 9.5V4.72222C18 4.32335 17.602 4 17.1111 4H2.88889C2.39797 4 2 4.32335 2 4.72222V16.2778C2 16.6767 2.39797 17 2.88889 17H11"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.05 10.5L8.30005 8V13L12.05 10.5Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 14.3L20 20.3"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.25 12.05L22.25 18.05"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="14" y="12" width="8.3" height="8.3" rx="0.8" stroke="currentColor" strokeWidth="1.13" />
    </svg>
  );
};

export const VideoMatteIcon = fplIcon(VideoMatteIconLocal, Icon24VideoMatteLarge);
